import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from '../../../headersService'

export const fetchMyProfile = createAsyncThunk('fetchMyProfile', async (_, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/tpo/my-profile`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const myProfileSlice = createSlice({
    name: 'TPO Profile',
    initialState: {
        loading: false,
        profileDetails: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMyProfile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchMyProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.profileDetails = action.payload
        })
        builder.addCase(fetchMyProfile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default myProfileSlice.reducer